import { render, staticRenderFns } from "./AiChatIcon.vue?vue&type=template&id=2b65c13a"
import script from "./AiChatIcon.vue?vue&type=script&lang=js"
export * from "./AiChatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_css-loader@6.11.0_webpack@5.104.1_cssnano@5_665be98a8828166c9882e9000b2a540b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports